// extracted by mini-css-extract-plugin
export default {"headerContentBox":"HeaderContentBox_headerContentBox__TdENp"};